import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["feedbackForm", "thumbsUp", "thumbsDown", "copyButton"]
  static values = {
    messageId: Number,
    content: String
  }

  connect() {
    this.currentFeedbackType = null
  }

  copyToClipboard(event) {
    event.preventDefault()
    const button = event.currentTarget

    // Get content from the actual message element (handles streaming updates)
    // Fall back to data attribute if element not found
    const contentElement = this.element.querySelector('.message-content')
    const content = contentElement ? contentElement.innerText.trim() : this.contentValue

    navigator.clipboard.writeText(content).then(() => {
      const originalHTML = button.innerHTML
      button.innerHTML = `
        <svg class="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
        </svg>
      `

      setTimeout(() => {
        button.innerHTML = originalHTML
      }, 2000)
    }).catch(err => {
      console.error('Failed to copy:', err)
    })
  }

  thumbsUp(event) {
    event.preventDefault()
    this.submitFeedback('thumbs_up', null)
  }

  thumbsDown(event) {
    event.preventDefault()
    if (this.hasFeedbackFormTarget) {
      this.feedbackFormTarget.classList.remove('hidden')
    }
  }

  submitFeedbackWithComment(event) {
    event.preventDefault()
    const comment = event.target.querySelector('textarea').value
    this.submitFeedback('thumbs_down', comment)
  }

  cancelFeedback(event) {
    event.preventDefault()
    if (this.hasFeedbackFormTarget) {
      this.feedbackFormTarget.classList.add('hidden')
      this.feedbackFormTarget.querySelector('textarea').value = ''
    }
  }

  async submitFeedback(type, comment) {
    try {
      const response = await fetch(`/messages/${this.messageIdValue}/feedback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({
          feedback_type: type,
          feedback_comment: comment
        })
      })

      if (response.ok) {
        this.currentFeedbackType = type
        this.updateFeedbackUI(type)
      }
    } catch (error) {
      console.error('Failed to submit feedback:', error)
    }
  }

  updateFeedbackUI(type) {
    if (this.hasThumbsUpTarget && this.hasThumbsDownTarget) {
      this.thumbsUpTarget.classList.remove('opacity-30', 'pointer-events-none')
      this.thumbsDownTarget.classList.remove('opacity-30', 'pointer-events-none')

      if (type === 'thumbs_up') {
        this.thumbsUpTarget.classList.add('text-green-600', 'opacity-100')
        this.thumbsUpTarget.classList.remove('opacity-60', 'hover:opacity-100')
        this.thumbsDownTarget.classList.remove('text-red-600', 'opacity-100')
        this.thumbsDownTarget.classList.add('opacity-60')
      } else {
        this.thumbsDownTarget.classList.add('text-red-600', 'opacity-100')
        this.thumbsDownTarget.classList.remove('opacity-60', 'hover:opacity-100')
        this.thumbsUpTarget.classList.remove('text-green-600', 'opacity-100')
        this.thumbsUpTarget.classList.add('opacity-60')

        if (this.hasFeedbackFormTarget) {
          this.feedbackFormTarget.classList.add('hidden')
        }
      }
    }
  }
}
